import isObject from '../utility/isObject';

class Card {
  public static fragmentsFields(): string {
    return `
      id
      object
      brand
      country
      cvcCheck
      expMonth
      expYear
      last4
      funding
    `;
  }

  public static fromJson(value: any): Card {
    if (!isObject(value)) {
      throw new TypeError('value must be an object for Card.fromJson(value).');
    }

    const id = value['id'];
    const object = value['object'];
    const brand = value['brand'];
    const country = value['country'];
    const cvcCheck = value['cvcCheck'];
    const expMonth = value['expMonth'];
    const expYear = value['expYear'];
    const last4 = value['last4'];
    const funding = value['funding'];

    return new Card({
      id,
      object,
      brand,
      country,
      cvcCheck,
      expMonth,
      expYear,
      last4,
      funding,
    });
  }

  public id: string | null;
  public object: string | null;
  public brand: string | null;
  public country: string | null;
  public cvcCheck: string | null;
  public expMonth: number | null;
  public expYear: number | null;
  public last4: string | null;
  public funding: string | null;
  public inputNumber: string | null;
  public inputCvc: string | null;
  public inputExpMonth: number | null;
  public inputExpYear: number | null;

  constructor(
    {
      id = null,
      object = null,
      brand = null,
      country = null,
      cvcCheck = null,
      expMonth = null,
      expYear = null,
      last4 = null,
      funding = null,
      inputNumber = null,
      inputCvc = null,
      inputExpMonth = null,
      inputExpYear = null,
    }: {
      id?: string | null,
      object?: string | null,
      brand?: string | null,
      country?: string | null,
      cvcCheck?: string | null,
      expMonth?: number | null,
      expYear?: number | null,
      last4?: string | null,
      funding?: string | null,
      inputNumber?: string | null,
      inputCvc?: string | null,
      inputExpMonth?: number | null,
      inputExpYear?: number | null,
    }) {
    this.id = id;
    this.object = object;
    this.brand = brand;
    this.country = country;
    this.cvcCheck = cvcCheck;
    this.expMonth = expMonth;
    this.expYear = expYear;
    this.last4 = last4;
    this.funding = funding;
    this.inputNumber = inputNumber;
    this.inputCvc = inputCvc;
    this.inputExpMonth = inputExpMonth;
    this.inputExpYear = inputExpYear;
  }

  public toJson(): object {
    return {
      number: this.inputNumber,
      cvc: this.inputCvc,
      expMonth: this.inputExpMonth,
      expYear: this.inputExpYear,
    }
  }
}

export default Card;
